import {agGridNextRecord, agGridPrevRecord} from "./records";
import {switchToGrid} from "./grid";
import {switchToDetail} from "./detail";
import {reloadGridDetailContent} from "../detail";

export let gridToolbarItems = [
	{
		type: "buttonGroup",
		buttons: [
			{
				icon: "arrow-w",
				click: agGridPrevRecord
			},
			{
				icon: "arrow-e",
				click: agGridNextRecord
			}
		]
	},
	{ type: "separator" },
	{
		id: "gridViewSwitcher",
		type: "buttonGroup",
		buttons: [
			{
				id: "switchToGrid",
				icon: "table",
				text: "Grid",
				togglable: true,
				group: "grid-switcher",
				toggle: switchToGrid,
				selected: true,
			},
			{
				id: "switchToDetail",
				icon: "table-properties",
				text: "Detail",
				togglable: true,
				group: "grid-switcher",
				toggle: function () {
					switchToDetail(false);
				}
			}
		]
	},
	{ type: "separator" },
	{
		id: "gridReload",
		type: "button",
		icon: "refresh-sm",
		click: function reload (event) {
			let $detail = $('#switchToDetail');
			if ($detail.hasClass('k-selected')) {
				reloadGridDetailContent();
			} else {
				fetchNewDataFromUrl(gridDataUrl);
			}
		}
	},
	{ type: "separator" },
];
